import { useEffect, useState } from 'react';
import api from '../services/api';

// Caché a nivel de módulo: Sidebar y ThemeBoot piden la config casi al mismo
// tiempo al cargar la app; con esto solo se hace un GET /configuracion, no dos.
let cache: Record<string, string> | null = null;
let promesa: Promise<Record<string, string>> | null = null;

function cargarConfig() {
  if (cache) return Promise.resolve(cache);
  if (!promesa) {
    promesa = api.get('/configuracion')
      .then(r => { cache = r.data; return cache!; })
      .catch(() => ({}));
  }
  return promesa;
}

export function useConfigNegocio() {
  const [config, setConfig] = useState<Record<string, string>>(cache || {});

  useEffect(() => {
    let vivo = true;
    cargarConfig().then(c => { if (vivo) setConfig(c); });
    return () => { vivo = false; };
  }, []);

  return config;
}

// Tras guardar en Ajustes: sin esto el resto del panel seguía con la config vieja
// (p. ej. el tema) hasta recargar la página.
export function refrescarConfigNegocio(nueva: Record<string, string>) {
  cache = nueva;
  promesa = Promise.resolve(nueva);
}
